import React, { Component } from 'react';
import { MDBIcon } from 'mdbreact';
import Footer from '../components/Principal/Footer';
import Header from '../components/Principal/Header';
import MensajeF from '../components/Mensaje_Flotante/MensajeF';

class ActualizacionWebDian extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadpage: false,
            titulo: 'CONOZCA LOS DOCUMENTOS RELACIONADOS CON LA ASAMBLEA GENERAL DE DELEGADOS UTRAHUILCA 2026',
            parrafos: [
                'El pasado 14 de marzo de 2026 se llevó a cabo la Sexagésima Cuarta (64) Asamblea General de Delegados de la Cooperativa UTRAHUILCA, donde asistieron 73 delegados principales y 12 suplentes comprometidos con la entidad solidaria y dispuestos a atender el orden del día.',
                'Consulte aquí la información enviada por UTRAHUILCA a la DIAN, para los Comentarios de la Sociedad Civil sobre la gestión realizada por la Cooperativa en el año gravable 2025, con motivo del proceso de actualización del Registro Web en dicha entidad de fiscalización.'
            ],
            documentos: [
                { nombrepdf: 'CertificacionRemuneraciones_2025', descripcion: 'Certificación Renúmeración Directivos y Gerenciales' },
                { nombrepdf: 'MemoriaEconomica_2025', descripcion: 'Memoria Económica 2025' },
                { nombrepdf: 'InformeGestion_2025', descripcion: 'Informe Gestión 2025' },
                { nombrepdf: 'EstadosFinan_Notas_DictamenRF_2025', descripcion: 'Estados Financieras y Notas EF - Dictamen 2025' },
                { nombrepdf: 'CertificacionCumplimientoRTE_2025', descripcion: 'Certificación Cumplimiento Requisitos' },
                { nombrepdf: 'Estatutos_2026', descripcion: 'Estatutos' },
                { nombrepdf: 'CertificadoAntecedentesJudiciales_2025', descripcion: 'Certificación Antecedentes Judiciales' },
                { nombrepdf: 'Acta64_AsambleaGeneral_2026', descripcion: 'Acta de Asamble 2026' },
                { nombrepdf: 'CertificadoExistencia_RepresentacionLegal_2026', descripcion: 'Certificado de Existencia y Representación Legal' },
                { nombrepdf: 'DeclarRentaUtrahuilca_2025', descripcion: 'Declaración de renta año gravable 2025' }
            ],
            fechas: { desde: '23 de junio de 2026', hasta: '2 de julio de 2026'}
        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({
                loadpage: true
            })
        }, 0.1)
    }

    render() {
        const { loadpage, titulo, parrafos, documentos, fechas } = this.state;

        let secciondocumentos = <></>;
        if (loadpage) {
            const seccioninformacion = <div className="py-5" style={{ background: '#20A150', height: '100%', width: '100%' }}>
                                           <div className="container">
                                               <div className="row pt-5">
                                                   <div className="col-lg-12 pt-5">
                                                       <p className="text-justify pt-3 pb-2" style={{ color: '#fff', fontSize: '22px', fontWeight: 'bold' }}>{titulo}</p>
                                                       {parrafos.map((parrafo, index) => (
                                                           <p key={index} className={`text-justify`} style={{ color: '#fff', fontSize: '18px', fontWeight: 'bold' }}>{parrafo}</p>
                                                       ))}
                                                   </div>
                                               </div>
                                           </div>
                                       </div>;
            secciondocumentos = <>
                                    {seccioninformacion}
                                    <div className="py-5 pt-4" style={{ background: '#fff', height: '100%', width: '100%' }}>
                                        <div className="container">
                                            <div className="row pt-2 pb-2">
                                                <div className="col-lg-12 pt-3 pb-3">
                                                    <table className="table table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">Documento</th>
                                                                <th scope="col">Descripción</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {documentos.map((documento, index) => (
                                                                <tr>
                                                                    <td>
                                                                        <a key={index} className="text-center d-flex justify-content-center" style={{ color: '#20A150' }} href={`/Documentos/ActualizacionDIAN/${documento.nombrepdf}.pdf`} target={'_blank'} rel="noopener noreferrer">
                                                                            <MDBIcon icon="fa fa-eye" size="1x" className="ico" style={{ paddingTop: '4px', paddingRight: '3px' }} /><span className="font-weight-bold">Ver Documento</span>
                                                                        </a>
                                                                    </td>
                                                                    <td>{documento.descripcion}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="col-lg-12 pt-3 pb-3">
                                                    <p className="text-justify pb-2" style={{ fontSize: '18px' }}>
                                                        Esta información fue publicada el <strong>{fechas.desde}</strong> y estará vigente hasta el <strong>{fechas.hasta}</strong> a las 06:00 PM.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>;
        }

        const jsx = <>
            <Header id={2} />
            <MensajeF />
            {secciondocumentos}
            <Footer />
        </>;
        return jsx;
    }
}

export default ActualizacionWebDian;